export const requiredField = 'Required'
export const requiredFieldWithName = (fieldName: string) => `${fieldName} is required`
export const invalidFieldWithName = (fieldName: string) => `${fieldName} is invalid`
export const noWhitespaces = 'There should be no spaces at the beginning and at the end'
export const invalidColor = 'Invalid color'
export const invalidUrl = 'Invalid URL'
export const invalidSubdomain = 'Only latin characters, numbers and - _ are allowed'
export const invalidName = 'Invalid name'
export const invalidFtpHost = 'Invalid FTP Host'
export const invalidEmail = ' Email is invalid'
export const invalidData = 'Date is invalid'
export const maxLength = (max: number) => `Maximum length is ${max} characters`
export const maxNumber = (max: number) => `Maximum value is ${max}`
export const minNumber = (min: number) => `Minimum value is ${min}`
export const maxLengthWithName = (fieldName: string, max: number) =>
  `${fieldName} should be of maximum ${max} characters length`
export const requiredBentleyAnalyticsReportFiles = 'Bentley Analytics Report requires one 3D model'
